import React, { useContext, useState } from 'react'
import { AppContext } from '../../Context'
import { Outlet, useNavigate} from 'react-router'

export const SimulationContext = React.createContext({})

function SimulationPage({ simulationOnly = false, ...props }) {
  const { employee } = useContext(AppContext)
  const [simulation, setSimulation] = useState({})
  const navigate = useNavigate()

  return employee ? (
      <SimulationContext.Provider value={ { simulation, setSimulation, parentHistory: navigate, simulationOnly } }>
        <Outlet />
      </SimulationContext.Provider>
  ) : null
}

export default SimulationPage
